import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ToastService } from '@shared/lib/services/toast.service';
import { UserService } from '../services/User.service';
import { makeListQueryKey } from './utils/user';
import { useTranslation } from 'react-i18next';
export function useUsers() {
    const projectId = process.env.CUSTOMER_PROJECT_ID;
    const { t } = useTranslation();
    const { data, isLoading, isError, error } = useQuery({
        queryKey: makeListQueryKey(projectId),
        queryFn: () => {
            return UserService.getUsers(projectId).catch(() => {
                throw new Error(t('Error occurred while loading the Users.'));
            });
        },
        enabled: !!projectId
    });
    const errorMessage = isError && error.message;
    useEffect(() => {
        if (errorMessage) {
            ToastService.error(errorMessage);
        }
    }, [errorMessage]);
    return {
        users: data || [],
        isLoading
    };
}
